import { Component, forwardRef } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

@Component({
  selector: "month-selector",
  templateUrl: "month-selector.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthSelector),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MonthSelector),
      multi: true,
    },
  ],
})
export class MonthSelector implements ControlValueAccessor {
  private selectedMonth: string = null;
  private selectedYear: string = null;
  private propagateChange = (_: any) => {};

  private months = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  };

  private years: number[] = [];
  objectKeys = Object.keys;

  constructor() {
    let currentYear = new Date().getFullYear();
    for (let i = 2015; i <= currentYear; i++) {
      this.years.push(i);
    }

    this.years = this.years.reverse();
  }

  private value(): Date {
    if (
      this.selectedMonth &&
      !isNaN(parseInt(this.selectedMonth)) &&
      this.selectedYear &&
      !isNaN(parseInt(this.selectedYear))
    ) {
      return new Date(
        parseInt(this.selectedYear),
        parseInt(this.selectedMonth),
        1
      );
    }

    return null;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {
    if (obj === null) {
      this.selectedMonth = null;
      this.selectedYear = null;
    }
  }

  validate({ value }: FormControl) {
    if (!value && value !== "") return false;

    return true;
  }

  onMonthChange($event) {
    this.selectedMonth = $event;
    this.propagateChange(this.value());
  }

  onYearChange($event) {
    this.selectedYear = $event;
    this.propagateChange(this.value());
  }
}



// WEBPACK FOOTER //
// ./src/components/common/month-selector/month-selector.component.ts